import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {skipToContentConfig} from '@app/config/SkipToContentConfig';
import {DcpGlobalMessageComponentModule} from '@app/global-message/global-message.module';
import {dialogLayoutConfig} from '@app/layout/dialog/layout-config';
import {provideConfig, provideDefaultConfig} from '@spartacus/core';
import {PageLayoutModule} from '@spartacus/storefront';
import {FooterModule} from './footer/footer.module';
import {HeaderModule} from './header/header.module';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule,
    PageLayoutModule,
    DcpGlobalMessageComponentModule,
    RouterModule,
  ],
  declarations: [],
  exports: [FooterModule, HeaderModule],
  providers: [
    provideDefaultConfig(dialogLayoutConfig),
    provideConfig(skipToContentConfig),
  ],
})
export class LayoutModule {}
